module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-touchend": ""
    },
    on: {
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.handleTouchEnd($event)
      }
    }
  }, [(_vm.show) ? _c('dof-overlay', _vm._b({
    ref: "overlay",
    attrs: {
      "show": _vm.haveOverlay && _vm.isOverShow,
      "data-evt-dofOverlayBodyClicked": ""
    },
    on: {
      "dofOverlayBodyClicked": _vm.dofOverlayBodyClicking
    }
  }, 'dof-overlay', _vm.overlayCfg, false)) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('div', {
    ref: "dof-confirm",
    staticClass: " weex-ct weex-div",
    class: ['dof-confirm', _vm.pos],
    style: (_vm._px2rem(_vm.padStyle, 75)),
    attrs: {
      "height": _vm._height,
      "hack": _vm.isNeedShow,
      "weex-type": "div"
    }
  }, [_vm._t("confirmContent", null, {}), _vm._v(" "), (_vm.title) ? _c('p', {
    staticClass: "confirm-title weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "confirm-content-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "confirm-content weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.content))])]), _vm._v(" "), _c('div', {
    staticClass: "confirm-buttons weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "confirm-button-left weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.leftBtnClick($event)
      }
    }
  }, [_c('p', {
    staticClass: "left-button weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.leftBtnText))])]), _vm._v(" "), _c('div', {
    staticClass: "confirm-button-right weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.rightBtnClick($event)
      }
    }
  }, [_c('p', {
    staticClass: "right-button weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.rightBtnText))])])]), _vm._v(" "), _c('div', {
    staticClass: " weex-ct weex-div",
    style: ({
      height: _vm._px2rem(_vm.isipx ? '68px' : '0px', 75),
      'background-color': '#ffffff'
    }),
    attrs: {
      "weex-type": "div"
    }
  })], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2214ea7b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2214ea7b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-confirm/index.vue
// module id = 586
// module chunks = 0 1